import { hookstate } from "@hookstate/core";

export const UserState = hookstate(null);
